export default class DmView
{
    constructor()
    {
        this.baseOptions = {
            type: 'doughnut',
            data: {
                labels: ['Level 1', 'Level 2', 'Level 3', 'Level 4'],
                datasets: [{
                    data: [25, 25, 25, 25],
                    backgroundColor: ['#e0e8ec', '#e0e8ec', '#e0e8ec', '#e0e8ec'],
                    borderColor: ['#ffffff', '#ffffff', '#ffffff', '#ffffff'],
                    borderWidth: 10
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                events: [],
                rotation: -130,
                circumference: 260,
                cutout: 80,
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false }
                }
            }
        };
        this.scoreOptions = {
            type: 'doughnut',
            data: {
                labels: ['Level 1', 'Level 2', 'Level 3', 'Level 4'],
                datasets: [{
                    data: [25, 25, 25, 25],
                    backgroundColor: ['rgba(255,0,0,0)', 'rgba(255,0,0,0)', 'rgba(255,0,0,0)', 'rgba(255,0,0,0)'],
                    borderColor: ['#ffffff', '#ffffff', '#ffffff', '#ffffff'],
                    borderWidth: 10
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                events: [],
                rotation: -130,
                circumference: 260,
                cutout: 65,
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false }
                }
            }
        };
    }

    createChart(sectionId, haveLevel, needLevel)
    {
        let currentBaseElement    = document.getElementById('current-dm-' + sectionId);
        let currentScoreElement   = document.getElementById('current-dm-score-' + sectionId);
        let projectedBaseElement  = document.getElementById('projected-dm-' + sectionId);
        let projectedScoreElement = document.getElementById('projected-dm-score-' + sectionId);

        let currentBaseChart   = new Chart(currentBaseElement, this.baseOptions);
        let projectedBaseChart = new Chart(projectedBaseElement, this.baseOptions);

        // Draw the levels on the charts
        let haveOptions = jQuery.extend(true, {}, this.scoreOptions);
        let needOptions = jQuery.extend(true, {}, this.scoreOptions);

        for(let i = 0; i < haveLevel; i++) {
            haveOptions.data.datasets[0].backgroundColor[i] = '#4893ef';
        }

        for(let j = -1; j < needLevel; j++) {
            needOptions.data.datasets[0].backgroundColor[j] = '#4893ef';
        }
        if (needLevel) {
            needOptions.data.datasets[0].backgroundColor[needLevel - 1] = '#ea4f28';
        }

        let currentScoreChart   = new Chart(currentScoreElement, haveOptions);
        let projectedScoreChart = new Chart(projectedScoreElement, needOptions);
    }
}
